import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CamionCajasConectadas;

export interface Props {
    value: Entity;
}

/**Muestra un CamionCajasConectadas */
export class ConexionComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;

    render() {
        const { value } = this.props;
        const { Cajas, Camion } = value;

        return (
            <kea.Panel title={Camion.Nombre} iconClass={fa("truck")}>
                <span style={{fontStyle: "italic"}}>
                    {Camion.NombreRuta}, {Camion.Posicion}
                </span>
                <ul>
                    {Cajas.map(x =>
                        <li>
                            {x.Nombre}
                        </li>
                    )}
                </ul>
            </kea.Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/conexiones/conexion.tsx